import { render, staticRenderFns } from "./PFSettlementDocuments.vue?vue&type=template&id=74326e13"
import script from "./PFSettlementDocuments.vue?vue&type=script&lang=js"
export * from "./PFSettlementDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports